'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@/shared/components/ui';
import type { FaturaStatus } from '../types';
import { faturaStatusConfig } from '../utils/faturaStatusConfig';
interface FaturaStatusBadgeProps {
  status: FaturaStatus;
}
export function FaturaStatusBadge(t0) {
  const $ = _c(6);
  const {
    status
  } = t0;
  const config = faturaStatusConfig[status];
  const Icon = config.icon;
  const t1 = config.variant === "brand" ? "brand" : config.variant;
  let t2;
  if ($[0] !== Icon) {
    t2 = <Icon />;
    $[0] = Icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== config.label || $[3] !== t1 || $[4] !== t2) {
    t3 = <Badge variant={t1} icon={t2}>{config.label}</Badge>;
    $[2] = config.label;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}